<template>
    <v-layout wrap>
        <v-flex xs12>
            <v-card class="rounded_card">
                <v-btn 
                  v-for="item in menu"
                  :key="item.link"
                  :to="item.link"
                  round
                  small
                  flat
                  class="blue--text"
                  >
                    {{ item.name }}
                </v-btn>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
  name: 'TicketsMenu',
  data () {
    return {
      menu: [
        { name: 'Sonko Tickets', link: '/ticketreplies/sonko' },
        { name: 'Expert Tickets', link: '/ticketreplies/expert' },
        { name: 'Vip Sonko Tickets', link: '/ticketreplies/vip_sonko' },
        /*{ name: 'Add Blog', link: '/create/blog' }*/
      ]
    }
  }
}
</script>